"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.upsellModalMap = exports.UpsellModalName = void 0;
var UpsellModalName;
(function (UpsellModalName) {
    UpsellModalName["retroGsGummy"] = "retro-gs-gummy";
    UpsellModalName["motoCapsule"] = "moto-capsule";
    UpsellModalName["uroUtCapsule"] = "uro-ut-capsule";
    UpsellModalName["uroVpCapsule"] = "uro-vp-capsule";
    UpsellModalName["gogoGummy"] = "gogo-gummy";
    UpsellModalName["discoGummy"] = "disco-gummy";
    UpsellModalName["floPmsGummy"] = "flo-pms-gummy";
    UpsellModalName["floPmsCapsule"] = "flo-pms-capsule";
    UpsellModalName["retroAcneCapsule"] = "retro-acne-capsule";
    UpsellModalName["uroVpUtCapsuleBundle"] = "uro-vp-ut-capsule-bundle";
    UpsellModalName["floMotoCapsuleBundle"] = "flo-moto-capsule-bundle";
    UpsellModalName["uroBsCapsule"] = "uro-bs-capsule";
    UpsellModalName["preggoCsCapsule"] = "preggo-cs-capsule";
    UpsellModalName["floOsCapsule"] = "flo-os-capsule";
    UpsellModalName["willoCapsule"] = "willo-capsule";
    UpsellModalName["preggoShCapsule"] = "preggo-sh-capsule";
    UpsellModalName["hormoneBalanceBundle"] = "hormone-balance-bundle";
    UpsellModalName["intHarmonyBundle"] = "intimate-harmony-bundle";
    UpsellModalName["sexCollection"] = "sex-collection";
    UpsellModalName["happyBodyBundle"] = "happy-body-bundle";
    UpsellModalName["menoCapsule"] = "meno-capsule";
    UpsellModalName["menoGummy"] = "meno-gummy";
    UpsellModalName["uroId"] = "uro-intimate-deodorant";
})(UpsellModalName = exports.UpsellModalName || (exports.UpsellModalName = {}));
exports.upsellModalMap = (_a = {},
    _a[UpsellModalName.retroGsGummy] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/retro-upsell-desktop.png?v=66021286640320156561677807887',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/retro-upsell-mobile.jpg?v=41443971109578528911677807887',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/products/OPProducts_RETRO-SF_1000x1000_510ebac8-94ae-4f20-b316-70bf3666abc6_500x500.png?v=1680280641',
        ],
        graphicsBlockClass: 'retro-gs',
        productName: 'RETRO Glowing Skin Gummy',
        productCount: '50 Gummies',
        title: 'Get Glowing',
        titleSecondary: 'Refresh your skin with RETRO',
        descriptions: [
            'Glow from within with RETRO daily skin gummies. These juicy peach flavored gummies are packed with research-backed antioxidants that support collagen production, may help reduce signs of aging, and improve skin texture for deeply hydrated and bouncy skin.*',
        ],
        keyFacts: ['VEGAN', 'NON-GMO', 'GLUTEN-FREE', 'CRUELTY-FREE'],
        ingredients: [
            {
                header: 'AstaReal® Astaxanthin',
                description: [
                    'A clinically studied, naturally occurring antioxidant produced by microalgae and phytoplankton. Clinical studies show astaxanthin locks in moisture and prevents water loss to help plump skin, improve texture, and may help reduce signs of aging.*',
                ],
            },
            {
                header: 'Hibiscus',
                description: [
                    'Known as “Nature’s Botox”, hibiscus is known for helping promote skin elasticity and improve hydration.*',
                ],
            },
            {
                header: 'Bamboo Extract',
                description: [
                    'Rich in amino acids and antioxidants, Bamboo Extract helps support a healthy skin barrier and collagen production.*',
                ],
            },
        ],
    },
    _a[UpsellModalName.motoCapsule] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/moto-upsell-desktop.png?v=133825158941739465041677807805',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/moto-upsell-mobile.jpg?v=47424578795192005761677807806',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/opcom-carousel-motocap-sfp_11795568-f7fe-4425-9ec9-530d40e43d96.png?width=500',
        ],
        graphicsBlockClass: 'moto',
        productName: 'Metabolism Boosting Support',
        productCount: '60 Calorie-Burning Capsules',
        titleAlt: 'Burn more calories*',
        descriptions: [
            'Sometimes your workout routine needs a boost. MOTO is formulated with powerful ingredients that support healthy metabolism, healthy weight management, calorie burning, and balanced blood sugar levels—so you can see real results.',
        ],
        keyFacts: ['VEGAN', 'NON-GMO', 'GLUTEN-FREE', 'CRUELTY-FREE'],
        ingredients: [
            {
                header: 'EGCG FROM GREEN TEA EXTRACT',
                description: [
                    'EGCG helps your body burn calories more effectively, especially when paired with exercise and a balanced diet. It is rich in catechins, which have been shown to assist in weight management by regulating the hormones that can enhance thermogenesis (aka: the process that boosts your body’s metabolic rate. Higher thermogenesis = more calories burned).*',
                ],
            },
            {
                header: 'CHROMIUM PICOLINATE',
                description: [
                    'Chromium Picolinate can help insulin do its job of metabolizing nutrients & balancing blood sugar levels—resulting in reduced hunger cravings.',
                ],
            },
            {
                header: 'BLACK CUMIN SEED EXTRACT',
                description: [
                    'Used since the ancient Egyptians, Black Cumin Seed has been shown to aid weight loss when combined with a lower calorie diet.*',
                ],
            },
        ],
    },
    _a[UpsellModalName.uroUtCapsule] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/uro-ut-upsell-desktop.png?v=83004440558392055751663027911',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/uro-ut-cap-learn-more-mobile.jpg?v=1700248023',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/carousel-URO-UT-sfp_2c8211d8-a6e7-4933-ad42-180336aba171.png?width=500',
        ],
        graphicsBlockClass: 'uro-ut',
        productName: 'Urinary Tract Protection',
        productCount: '60 Capsules',
        title: 'Easy Peesy',
        descriptions: [
            'Peeing should be simple, but sex, sweat & stress often get in the way. URO is formulated with clinically-proven ingredients to:',
            'Promote urinary tract health & comfort*',
            'Help stop bacterial buildup in the urethra*',
            'Support normal urinary frequency*',
        ],
        keyFacts: ['ANTIBIOTICS-FREE', 'GLUTEN-FREE', '100% VEGAN', 'NON-GMO'],
        ingredients: [
            {
                header: 'PACRAN® COMPLETE CRANBERRY',
                description: [
                    'Most extensively studied & scientifically-proven cranberry product for urinary tract health',
                    'Cranberries contain special proanthocyanidins (PACs) that help prevent harmful bacteria from sticking to the urethra',
                ],
            },
            {
                header: 'D-MANNOSE',
                description: [
                    'Forms a film over urinary tract lining cells to protect from bacterial buildup',
                    'May help prolong the time between UTIs',
                ],
            },
            {
                header: 'VITAMIN C',
                description: [
                    'Acidifies the urine to create an inhospitable environment for harmful bacteria',
                ],
            },
        ],
    },
    _a[UpsellModalName.uroVpCapsule] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/uro-vp-upsell-desktop.png?v=78073188660635760051663289470',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/uro-vp-upsell-mobile.png?v=67742455245227329291663289470',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/OPProductsSupplementFacts_TEMPLATE_UROVPSFP_96a35728-9547-4c87-ad8c-fecffc78d5d7.png?width=500',
        ],
        graphicsBlockClass: 'uro-vp',
        productName: 'URO Vaginal Probiotics',
        productCount: '60 Vegan Capsules',
        title: "Supercharge your vagina's ",
        titleSecondary: 'natural defense system',
        descriptions: [
            'URO Vaginal Probiotic is formulated with a proprietary blend of premium probiotics & XOS prebiotics to promote healthy vaginal pH, odor, yeast balance & flora.',
        ],
        keyFacts: ['5 BILLION CFUs', 'NON-GMO', '100% VEGAN', 'GLUTEN-FREE'],
        ingredients: [
            {
                header: 'V-Positiv Probiotic Blend™',
                description: [
                    '4 powerful strains with 5 billion CFUs for enhanced protection.',
                    'Lactobacillus Acidophilus - Helps target vaginal inflammation and digestive issues',
                    'Lactobacillus Rhamnosus - Promotes balance in vagina & gastrointestinal tract',
                    'Lactobacillus Reuteri - Has antimicrobial, immune-boosting & anti-inflammatory properties',
                    'Lactobacillus Fermentum - Has immune-boosting & antimicrobial properties',
                ],
            },
            {
                header: 'XOS PREBIOTICS',
                description: ['Acts as food for the probiotics to keep them active'],
            },
        ],
    },
    _a[UpsellModalName.gogoGummy] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/gogo-upsell-desktop.png?v=144433795109562532051677807701',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/gogo-upsell-mobile.png?v=146813059411739948521677807702',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/OP-carousel-gogo-sfp.png?v=1693418802',
        ],
        graphicsBlockClass: 'gogo',
        productName: 'GOGO Fiber Gummy',
        productCount: '60 Gummies',
        title: 'Poop Better *',
        descriptions: [
            'Feel lighter with GOGO premium fiber gummies. Derived from chicory root, these tasty gummies are a vegan, natural source of prebiotic fiber that promotes good gut bacteria. A daily dose of GOGO can help you (and your digestive system) do some good.*',
        ],
        keyFacts: ['VEGAN', 'NON-GMO', 'GLUTEN-FREE', 'CRUELTY-FREE'],
        ingredients: [
            {
                header: 'Chicory Root',
                description: [
                    'A member of the dandelion family, chicory root has been used for nutritional and medicinal purposes for thousands of years. Chicory root derived fiber, inulin, travels through the small intestine and stimulates the growth of healthy gut bacteria to support regularity.*',
                ],
            },
        ],
    },
    _a[UpsellModalName.discoGummy] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/flo-multi-learn-more-desktop.png?v=1704414218',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/flo-multi-learn-more-mobile.png?v=1704414217',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/products/OPProducts_DISCO-SF_1000x1000_51874653-40d6-4be6-b436-451ddc605cf5_500x500.png?v=1680280718',
        ],
        graphicsBlockClass: 'flo',
        productName: "Women's Multi Gummy Vitamin",
        productCount: '60 Tropical Flavored Gummies',
        title: 'Sweeten Your Routine',
        descriptions: [
            'It’s time to enjoy taking your daily multivitamin—not get it over with. FLO Multi’s thoughtful mix of vitamins, minerals, and adaptogens (like Ashwagandha & Rhodiola), specially formulated for women to help fill common nutritional gaps. This is your childhood multivitamin re-imagined; a sweet cocktail of pineapple, tropical punch, and strawberry flavored gummies to excite your tastebuds in a new way, every day.*',
        ],
        keyFacts: ['VEGAN', 'NON-GMO', 'GLUTEN-FREE', 'CRUELTY-FREE'],
        ingredients: [
            {
                header: 'ADAPTOGENS',
                description: [
                    'Adaptogens help your body improve its ability to handle internal & external changes by supporting internal balance. Ashwagandha & Rhodiola traditionally help with stress relief & cognitive function.',
                ],
            },
            {
                header: 'DHA',
                description: [
                    'This omega-3 fatty acid is known to help support circulation & your body’s natural anti inflammatory responses. FLO Multi contains an algae-derived DHA, because let’s be honest, non-vegan supplements should be left in the past.',
                ],
            },
            {
                header: 'FOLATE',
                description: [
                    'The natural form of Vitamin B9, Folate plays an important role in red blood cell formation, as well as healthy cell growth & function. Folate supplements have been been shown to help improve energy and mood.',
                ],
            },
            {
                header: 'BIOTIN',
                description: [
                    'Biotin is one of the B complex vitamins that help the body convert food into energy, and taking it as a supplement may help support healthy skin, hair, and nails.',
                ],
            },
            {
                header: 'OTHER VITAMINS & MINERALS',
                description: [
                    'Vitamins A, C, D3, E, B1, B2, B3, B6 & B12. Minerals Iodine, Zinc & Selenium',
                ],
            },
        ],
    },
    _a[UpsellModalName.retroAcneCapsule] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0013/1068/7335/files/opcom-desktop-image.png?v=1675882572',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/retro-acne-cap-learn-more-mobile.jpg?v=1700248023',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/products/OP-carousel-SFP_500x500.png?v=1683664044',
        ],
        graphicsBlockClass: 'retro-acne',
        productName: 'RETRO Acne Relief Capsules',
        productCount: '60 Vegetarian Capsules',
        title: 'Your Search for Clear Skin',
        titleSecondary: 'Ends Now',
        descriptions: [
            'Struggling with pimples, whiteheads & blackheads, face or body acne? RETRO is formulated with an ingredient blend clinically proven to reduce acne.',
        ],
        keyFacts: ['NON-GMO', 'VEGETARIAN', 'CRUELTY FREE'],
        ingredients: [
            {
                header: 'Lactoferrin',
                description: [
                    'Lactoferrin is a vegetarian protein traditionally used to boost immunity, but science has recently discovered its ability to prevent all types of common acne.',
                ],
            },
            {
                header: 'Zinc',
                description: [
                    'Zinc plays an important role in maintaining normal oil production in the skin & supports healthy inflammatory response.',
                ],
            },
            {
                header: 'Vitamin E',
                description: [
                    'Vitamin E is a fat-soluble antioxidant that helps protect the skin by neutralizing free radicals.',
                ],
            },
        ],
    },
    _a[UpsellModalName.floPmsCapsule] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/flo-capsule-upsell-desktop.png?v=75651533812508756541677807639',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/flo-cap-learn-more-mobile.jpg?v=1700248023',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/OPProducts_FLO-Capsule-SF_1000x1000_d44d9bd5-2162-4c1c-abec-a4d76c7abc3e.png?width=500',
        ],
        graphicsBlockClass: 'flo',
        productName: 'FLO PMS Relief',
        productCount: '30 Sugar-Free Capsules',
        title: 'PMS sucks.',
        titleSecondary: 'FLO makes it suck less *',
        descriptions: [
            "FLO's plant-based ingredients help balance your hormones to relieve painful PMS symptoms like period breakouts, bloating, mood swings & more.",
        ],
        keyFacts: ['HORMONE-FREE', 'GLUTEN-FREE', '100% VEGAN', 'NON-GMO'],
        ingredients: [
            {
                header: 'Chasteberry',
                description: [
                    'A small-yet-mighty berry that helps promote hormonal balance for PMS symptom relief.',
                ],
            },
            {
                header: 'Lemon Balm',
                description: [
                    'Best known for its calming qualities, traditionally used for cramp relief and mood.',
                ],
            },
            {
                header: 'Dong Quai',
                description: ['Traditionally used as an antispasmodic for cramp relief.'],
            },
            {
                header: 'Vitamin B6',
                description: ['Historically used to reduce hormonal mood swings & cravings.'],
            },
        ],
    },
    _a[UpsellModalName.floPmsGummy] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/flo-learnmore-image-desktop.png?v=1687300002',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/flo-learnmore-image-mobile.png?v=1687300002',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/products/FLO_Gummy_CombinedLabel_12.9.21_b665ce0b-23d7-405c-a942-f5c3b3c47c8b_500x500.png?v=1680217336',
        ],
        graphicsBlockClass: 'flo',
        productName: 'FLO PMS Relief',
        productCount: '60 Gummies',
        title: 'PMS sucks.',
        titleSecondary: 'FLO makes it suck less.',
        descriptions: [
            "FLO's plant-based ingredients help balance your hormones to relieve painful PMS symptoms like period breakouts, bloating, mood swings & more.",
        ],
        keyFacts: ['HORMONE-FREE', 'GLUTEN-FREE', '100% VEGAN', 'NON-GMO'],
        ingredients: [
            {
                header: 'Chasteberry',
                description: [
                    'A small-yet-mighty berry that helps promote hormonal balance for PMS symptom relief.',
                ],
            },
            {
                header: 'Lemon Balm',
                description: [
                    'Best known for its calming qualities, traditionally used for cramp relief and mood.',
                ],
            },
            {
                header: 'Dong Quai',
                description: ['Traditionally used as an antispasmodic for cramp relief.'],
            },
            {
                header: 'Vitamin B6',
                description: ['Historically used to reduce hormonal mood swings & cravings.'],
            },
        ],
    },
    _a[UpsellModalName.uroVpUtCapsuleBundle] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/uro-vp-ut-bundles-upsell-desktop.png?v=67385148932778176901677114574',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/t/27/assets/uro-vp-ut-bundles-upsell-mobile.png?v=17391217880216891301677114575',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/sfp-vp_df5be3c8-3e76-47b2-b7da-28f31cef13c0.png?v=1685427125',
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/sfp-ut_25b16036-d215-42cb-99ee-642f76e749f5.png?v=1684598568',
        ],
        graphicsBlockClass: 'uro-vp',
        productName: 'Vaginal & Urinary Health Bundle',
        productCount: '2 URO Vaginal Probiotic Capsules + 2 URO Urinary Tract Capsules',
        title: 'Better Urogenital Health ',
        titleSecondary: 'Starts Here',
        descriptions: [
            'URO Vaginal Probiotic promotes healthy vaginal pH, odor, yeast balance & flora, while URO Urinary Tract Capsules help stop bacterial buildup in the urethra to promote urinary tract health & comfort, and support normal urinary frequency.',
        ],
        keyFacts: ['100% VEGAN', 'GLUTEN-FREE', 'NON-GMO'],
        ingredients: [
            {
                header: 'URO VAGINAL PROBIOTIC',
                description: ['Proprietary V-Positiv Probiotic Blend™ & XOS Prebiotics'],
            },
            {
                header: 'URO URINARY TRACT',
                description: ['Pancran® Complete Cranberry, D-Mannose, & Vitamin C'],
            },
        ],
    },
    _a[UpsellModalName.floMotoCapsuleBundle] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/metabolism-period-bundle-learnmore-image-desktop.png?v=1687277206',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/metabolism-period-bundle-learnmore-image-mobile.png?v=1687277206',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/sfp-moto_2ce67cba-5983-4a45-b7ed-16e7e934ea26.png?v=1685427125',
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/sfp-flo_2db983dd-3019-43dd-b558-d86560c17010.png?v=1684723067',
        ],
        graphicsBlockClass: 'moto',
        productName: 'Metabolism + Period Bundle',
        productCount: '2 MOTO Capsules + 2 FLO Capsules',
        title: 'Metabolism-boosting PMS Relief',
        descriptions: [
            'FLO’s all-star ingredients help balance hormones to kick PMS symptoms to the curb. MOTO’s sugar-free capsules are formulated to partner up with your fitness routine to support metabolism, weight management, calorie burning and balanced blood sugar levels.',
        ],
        keyFacts: ['100% VEGAN', 'GLUTEN-FREE', 'NON-GMO'],
        ingredients: [
            {
                header: 'MOTO',
                description: [
                    'EGCG from Green Tea Extract, Chromium Picolinate, Black Cumin Seed Extract, & Vitamin B12',
                ],
            },
            {
                header: 'FLO',
                description: ['Chasteberry, Dong Quai, Lemon Balm, Vitamin B6'],
            },
        ],
    },
    _a[UpsellModalName.uroBsCapsule] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/flo-bladder-upsell-desktop.png?v=1709760279&width=400',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/flo-bladder-upsell-mobile-1.jpg?v=1709843177&width=900',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/OP-carousel-uro-bladder-sfp_b40520f8-737b-495a-a936-8fb96f7325f2.png?v=1709760888',
        ],
        graphicsBlockClass: 'uro-bs',
        productName: 'Bladder Control',
        productCount: '60 Capsules',
        title: 'Stop running to the bathroom a million times a day',
        descriptions: [
            'In a 12-week clinical study using a daily dose of ingredients found in URO Bladder Control, 90% of people reported an improvement in bladder issues like urinary frequency, urinary urgency, and urinary leakage*',
        ],
        keyFacts: ['100% VEGAN', 'NON-GMO', 'GLUTEN-FREE', 'CRUELTY-FREE'],
        ingredients: [
            {
                header: 'Pumpkin Seed Extract',
                description: [
                    'Naturally rich in B vitamins, amino acids, iron & zinc, pumpkin seed extract is a powerhouse ingredient known to improve structural support of the bladder, which helps normalize urinary control.*',
                ],
            },
            {
                header: 'Soy Germ Extract',
                description: [
                    'A naturally powerful plant extract known to support healthy bladder function, and help relieve occasional urinary distress when combined with pumpkin seed extract.*',
                ],
            },
            {
                header: 'Saw Palmetto',
                description: [
                    'The fruits of the saw palmetto plant have a long history of use for supporting healthy urinary function.*',
                ],
            },
        ],
    },
    _a[UpsellModalName.floOsCapsule] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/ovarian-support-upsell-desktop.png?v=1714071512&width=800',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/ovarian-support-upsell-mobile.jpg?v=1714071512&width=900',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/OP-carousel-flo-ov-sfp.png?v=1711399626&width=700',
        ],
        graphicsBlockClass: 'flo-os',
        productName: 'FLO Ovarian Support',
        productCount: '90 Capsules',
        title: 'Break Bad Cycles',
        descriptions: [
            'Healthy ovarian function is important for healthy hormone balance, regular periods, reproductive health, and healthy weight management. FLO Ovarian Support is a daily vitamin to support healthy ovulation & hormone regulation, formulated with the ideal 40:1 ratio of inositols, DIM, and folic acid.*',
        ],
        keyFacts: ['100% VEGAN', 'GLUTEN-FREE', 'NON-GMO'],
        ingredients: [
            {
                header: 'Myo-Inositol & D-Chiro-Inositol',
                description: [
                    'This formula combines Myo-Inositol and D-Chiro-Inositol at a 40:1 ratio (the ideal ratio that is naturally occurring in the body) to help support ovarian health, menstrual cycle regularity & healthy blood sugar levels.*',
                ],
            },
            {
                header: 'Diindolylmethane (DIM)',
                description: [
                    'DIM, a compound found in leafy greens, helps support healthy hormone balance and promotes healthy hormonal weight management.*',
                ],
            },
            {
                header: 'Folic Acid',
                description: ['Folic acid is a key B vitamin involved in normal reproductive health.*'],
            },
        ],
    },
    _a[UpsellModalName.preggoCsCapsule] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/preggo-female-learnmore-mobile.png?v=1709593659',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/preggo-female-learnmore-desktop.jpg?v=1709593677',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/PREGGO-Carousel-Conception-SFP_6555c688-b1e0-4f24-a5da-d0890d3c9a88.jpg?v=1709326045',
        ],
        graphicsBlockClass: 'preggo',
        productName: 'Conception Support Capsules',
        productCount: '60 Capsules',
        title: 'Getting Pregnant is Hard',
        titleSecondary: '',
        titleAlt: '',
        descriptions: [
            'PREGGO Conception Support is OBGYN-formulated with ingredients used to support reproductive health*, prenatal nutrition*, healthy conception and female sexual health*',
        ],
        keyFacts: ['100% VEGAN', 'GLUTEN-FREE', 'NON-GMO'],
        ingredients: [
            {
                header: 'COQ10 & N-ACETYL CYSTEINE',
                description: [
                    'Powerful antioxidants that help reduce oxidative stress on the reproductive system, to help support healthy conception and egg health.*',
                ],
            },
            {
                header: 'MACA ROOT',
                description: [
                    'An adaptogen traditionally used to support healthy mood balance & female sexual health.*',
                ],
            },
            {
                header: 'VEGAN OMEGA-3S',
                description: [
                    'Research shows omega-3 fatty acids play an important role in heart & brain health and healthy conception.*',
                ],
            },
            {
                header: 'CONCEPTION SUPPORT NUTRIENTS',
                description: [
                    'Folic Acid, Iodine, Zinc & Selenium to help support women’s health while trying to get pregnant.*',
                ],
            },
        ],
    },
    _a[UpsellModalName.willoCapsule] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/desktop-willo-img.png?v=1714515858&width=800',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/mobile-willo-img.jpg?v=1714515859&width=900',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/OP-carousel-sfp_1_8f05e3f3-70cb-4c50-8d67-35d9dc555f97.png?v=1714427741&width=700',
        ],
        graphicsBlockClass: 'willo',
        productName: 'WILLO Hair Growth Support',
        productCount: '60 Vegan Capsules',
        title: 'Reboot Your Roots',
        descriptions: [
            'WILLO is formulated with powerful biotin complex Lustriva®. When taken daily, women saw significant improvement in hair thickness in just 3 weeks☨',
            "WILLO's formula helps support: Thicker & Fuller Hair, Healthy Hair Growth, Hair Follicle Health, Healthy Stress Management*",
            '☨In a clinical study using an ingredient found in WILLO Hair Growth',
        ],
        keyFacts: ['100% VEGAN', 'NON-GMO', 'GLUTEN-FREE', 'CRUELTY-FREE'],
        ingredients: [
            {
                header: 'Biotin Complex LUSTRIVA®',
                description: [
                    'Clinically-studied & patented Lustriva® is an enhanced-bioavailable complex of biotin (a vital B vitamin involved in the synthesis of hair, skin & nails), silicon (a mineral found in healthy hair, skin & nails) & arginine (an essential amino acid involved in healthy blood flow).',
                ],
            },
            {
                header: 'Saw Palmetto Extract',
                description: [
                    'Saw palmetto extract has been shown to help manage our body’s levels of DHT (a hormone known to cause hair follicles to shrink), thus contributing to healthy hair follicles.*',
                ],
            },
            {
                header: 'Holy Basil',
                description: ['An adaptogen traditionally used to support healthy stress management.*'],
            },
            {
                header: 'Hair & Scalp Nutrients',
                description: [
                    'A blend of vitamins & minerals that help fill nutrient deficiencies that may cause thinning, brittle hair.* This blend includes vitamins B12, C, D3 & E, folate, iron, selenium & zinc.',
                ],
            },
        ],
    },
    _a[UpsellModalName.preggoShCapsule] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/preggo-sperm-learn-more-desktop.png?v=1716414615',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/preggo-sperm-learn-more-mobile.jpg?v=1716414615',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/PREGGO-Carousel-Sperm-SFP.png?v=1716414714',
        ],
        graphicsBlockClass: 'preggo-sh',
        productName: 'Sperm Health Support Capsules',
        productCount: '60 Capsules',
        title: 'It Takes Two',
        titleSecondary: '',
        titleAlt: '',
        descriptions: [
            'Studies show egg & sperm health each contribute to about 50% of conception challenges. It’s important to make sure both sides are covered. Sperm Health Support is OBGYN-formulated with ingredients used to support sperm count & motility*, healthy testosterone*, healthy conception* and male sexual health*',
        ],
        keyFacts: ['100% VEGAN', 'GLUTEN-FREE', 'NON-GMO'],
        ingredients: [
            {
                header: 'Alpha Lipoic Acid & N-Acetyl Cysteine',
                description: [
                    'Powerful antioxidants that help reduce oxidative stress on the reproductive system, to help support healthy conception and egg health.*',
                ],
            },
            {
                header: 'Tongkat Ali',
                description: [
                    'An adaptogen traditionally used to support healthy mood balance & female sexual health.*',
                ],
            },
            {
                header: 'Sperm Health Nutrients',
                description: [
                    'Research shows omega-3 fatty acids play an important role in heart & brain health and healthy conception.*',
                ],
            },
        ],
    },
    _a[UpsellModalName.hormoneBalanceBundle] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/HB-LearnMore-Desktop.png?v=1719266916',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/HB-LearnMore-Mobile.jpg?v=1719266916',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/FLO-PMS-SFP.jpg?v=1717716218',
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/FLO-OS-SFP.jpg?v=1717716219',
        ],
        graphicsBlockClass: 'flo-os',
        productName: 'Hormone Balance Kit',
        productCount: '2 Product Bundle',
        title: 'Holistic Support for Menstrual & Ovarian Health',
        titleSecondary: '',
        titleAlt: '',
        descriptions: [
            'FLO Ovarian Support is formulated to help with healthy ovarian function all month long, with ingredients shown to support cycle regularity, healthy ovulation, and hormonal weight management. FLO PMS Relief contains ingredients used for centuries to help balance hormones and proactively alleviate period symptoms like bloating, hormonal breakouts, mood swings and cramps.*',
        ],
        keyFacts: ['GLUTEN-FREE', 'VEGAN', 'NON-GMO'],
        ingredients: [
            {
                header: 'FLO Ovarian Support',
                description: ['DIM, Myo-Inositol, D-Chiro-Inositol, Folic Acid'],
            },
            {
                header: 'FLO PMS Relief',
                description: ['Chasteberry, Dong Quai, Lemon Balm, Vitamin B6'],
            },
        ],
    },
    _a[UpsellModalName.intHarmonyBundle] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/IHB-LearnMore-Desktop.png?v=1719267550',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/IHB-LearnMore-Mobile.jpg?v=1719267550',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/FLO-PMS-SFP.jpg?v=1717716218',
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/URO-VP-SFP.png?v=1714079207',
        ],
        graphicsBlockClass: 'uro-vp',
        productName: 'Intimate Harmony Bundle',
        productCount: '2 Product Bundle',
        title: 'Designed to Help Balance Hormones & Vaginal pH',
        titleSecondary: '',
        titleAlt: '',
        descriptions: [
            'URO Vaginal Probiotic helps crowd out harmful bacteria to support healthy vaginal pH, odor, flora & yeast balance. FLO PMS Relief is formulated to help balance hormones for proactive relief from PMS symptoms like hormonal breakouts, bloating, cramps & mood swings.*',
        ],
        keyFacts: ['GLUTEN-FREE', 'VEGAN', 'NON-GMO'],
        ingredients: [
            {
                header: 'URO Vaginal Probiotic',
                description: [
                    'V-Positiv Probiotic Blend™ (Lactobacillus acidophilus, Lactobacillus rhamnosus, Lactobacillus reuteri, Lactobacillus fermentum), XOS prebiotics',
                ],
            },
            {
                header: 'FLO PMS Relief',
                description: ['Chasteberry, Dong Quai, Lemon Balm, Vitamin B6'],
            },
        ],
    },
    _a[UpsellModalName.sexCollection] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/SC-LearnMore-Desktop.png?v=1719269515',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/SC-LearnMore-Mobile.jpg?v=1719269515',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/FLO-PMS-SFP.jpg?v=1717716218',
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/sfp-vp_df5be3c8-3e76-47b2-b7da-28f31cef13c0.png?v=1685427125',
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/URO-UT-SFP_fe761065-5d20-4b8e-8118-e7b57a101f16.png?v=1714079207',
        ],
        graphicsBlockClass: 'uro-ut',
        productName: 'Sex Collection',
        productCount: '3 Product Bundle',
        title: 'Unlock Better Sex*',
        titleSecondary: '',
        titleAlt: '',
        descriptions: [
            'The Sex Collection takes special care of the most intimate & vulnerable parts of you—so you can get back on top... literally. FLO PMS Relief calls on tried-and-true herbal ingredients that help balance hormones to fight period breakouts & bloating. URO Vaginal Probiotic helps balance vaginal pH & flora for healthier odor, discharge & yeast balance. URO Urinary Tract  is formulated to help protect the urethra from bacterial buildup to promote urinary health & comfort.',
        ],
        keyFacts: ['GLUTEN-FREE', 'VEGAN', 'NON-GMO'],
        ingredients: [
            {
                header: 'FLO PMS Relief',
                description: ['Chasteberry, Dong Quai, Lemon Balm, Vitamin B6'],
            },
            {
                header: 'URO Urinary Tract Protection',
                description: ['Pacran(R) Cranberry, D-Mannose, Vitamin C'],
            },
        ],
    },
    _a[UpsellModalName.happyBodyBundle] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/HBB-LearnMore-Desktop.png?v=1719269954',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/HBB-LearnMore-Mobile.jpg?v=1719269954',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/sfp-vp_df5be3c8-3e76-47b2-b7da-28f31cef13c0.png?v=1685427125',
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/OP-carousel-moto-sfp.png?v=1693418802',
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/sfp-gogo.png?v=1685427125',
        ],
        graphicsBlockClass: 'gogo',
        productName: 'Happy Body Bundle',
        productCount: '3 Product Bundle',
        title: 'Feel Better Naked',
        titleSecondary: '',
        titleAlt: '',
        descriptions: [
            'URO Vaginal Probiotic promotes healthy vaginal pH, odor, yeast balance & flora. GOGO Bloating + Gas Relief is designed to help break down hard-to-digest foods (like gluten & lactose) for proactive relief from excessive gas, uncomfortable bloating, and other digestive discomfort. MOTO Metabolism Support partners with your fitness routine to support a boosted metabolism and help you burn more calories.*',
        ],
        keyFacts: ['GLUTEN-FREE', 'VEGAN', 'NON-GMO'],
        ingredients: [
            {
                header: 'URO Vaginal Probiotic',
                description: [
                    'V-Positiv Probiotic Blend™ (Lactobacillus acidophilus, Lactobacillus rhamnosus, Lactobacillus reuteri, Lactobacillus fermentum), XOS prebiotics',
                ],
            },
            {
                header: 'GOGO Bloating + Gas Relief',
                description: [
                    'Proprietary Enzyme Blend (Bromelain, Alpha-Galactosidase, Amylase, Lipase, Lactase), Ginger Root, Milk Thistle, Artichoke Leaf, Dandelion Leaf, Peppermint, Caraway, Turmeric, Bacillus coagulans',
                ],
            },
            {
                header: 'MOTO Metabolism Support',
                description: [
                    'Green Tea Extract (EGCG), Chromium Picolinate, Black Cumin Seed, Vitamin B12',
                ],
            },
        ],
    },
    _a[UpsellModalName.menoCapsule] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/MENO-Capsule-Desktop.png?v=1721156927',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/MENO-Capsule-Mobile.jpg?v=1721156928',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/MENO-Capsule-SFP.jpg?v=1717101907',
        ],
        graphicsBlockClass: 'meno',
        productName: 'Menopause Support Capsules',
        productCount: '60 Capsules',
        title: 'Get Your Body Back',
        titleSecondary: '',
        titleAlt: '',
        descriptions: [
            'The daily, hormone-free menopause capsule is formulated with clinically-studied Black Cohosh, Chasteberry, and Ashwagandha for multi-symptom relief from hot flashes, night sweats, mood swings, and occasional sleeplessness.',
        ],
        keyFacts: ['GLUTEN-FREE', 'VEGAN', 'NON-GMO'],
        ingredients: [
            {
                header: 'BLACK COHOSH',
                description: [
                    'For thousands of years, Black Cohosh has been used for targeted relief from menopause symptoms. The flowering herb has a serotonin-like effect, which can impact the body’s temperature-regulating ability, ultimately providing relief from hot flashes & night sweats.*',
                ],
            },
            {
                header: 'ASHWAGANDHA KSM-66®',
                description: [
                    'Ashwagandha supports a healthy response to stress, brain function, sleep, and more. Regulating these bodily functions is key to support menopause and offer menopause symptom relief. Ashwagandha can help with occassional sleeplessness, stress, & anxiousness, and promote calm & relaxation. As with all adaptogens, taking Ashwagandha consistently over long periods of time can yield more powerful results.*',
                ],
            },
            {
                header: 'CHASTEBERRY',
                description: [
                    'Studies have shown Chasteberry helps decrease levels of the hormone prolactin, which then helps rebalance other hormones like estrogen and progesterone. This balancing act has been shown to reduce menopause symptoms like mood swings, hormonal weight gain, and headaches. It can also help relieve menopausal anxiousness.',
                ],
            },
            {
                header: 'VITAMINS D3 & B6',
                description: [
                    "Vitamin D3 improves your body’s ability to absorb calcium, which is increasingly important as you get older because it helps strengthen your bones. Vitamin B6 offers immunity support. Together they enhance MENO's formula as a holistic menopause supplement.*",
                ],
            },
        ],
    },
    _a[UpsellModalName.menoGummy] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/MENO-Gummy-Desktop.png?v=1721156928',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/MENO-Gummy-Mobile.jpg?v=1721156928',
        sfpImages: [
            'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/MENO-Capsule-SFP.jpg?v=1717101907',
        ],
        graphicsBlockClass: 'meno',
        productName: 'Menopause Support Gummies',
        productCount: '60 Gummies',
        title: 'Get Your Body Back',
        titleSecondary: '',
        titleAlt: '',
        descriptions: [
            'The daily, hormone-free menopause capsule is formulated with clinically-studied Black Cohosh, Chasteberry, and Ashwagandha for multi-symptom relief from hot flashes, night sweats, mood swings, and occasional sleeplessness.',
        ],
        keyFacts: ['GLUTEN-FREE', 'VEGAN', 'NON-GMO'],
        ingredients: [
            {
                header: 'BLACK COHOSH',
                description: [
                    'For thousands of years, Black Cohosh has been used for targeted relief from menopause symptoms. The flowering herb has a serotonin-like effect, which can impact the body’s temperature-regulating ability, ultimately providing relief from hot flashes & night sweats.*',
                ],
            },
            {
                header: 'ASHWAGANDHA KSM-66®',
                description: [
                    'Ashwagandha supports a healthy response to stress, brain function, sleep, and more. Regulating these bodily functions is key to support menopause and offer menopause symptom relief. Ashwagandha can help with occassional sleeplessness, stress, & anxiousness, and promote calm & relaxation. As with all adaptogens, taking Ashwagandha consistently over long periods of time can yield more powerful results.*',
                ],
            },
            {
                header: 'CHASTEBERRY',
                description: [
                    'Studies have shown Chasteberry helps decrease levels of the hormone prolactin, which then helps rebalance other hormones like estrogen and progesterone. This balancing act has been shown to reduce menopause symptoms like mood swings, hormonal weight gain, and headaches. It can also help relieve menopausal anxiousness.',
                ],
            },
            {
                header: 'VITAMINS D3 & B6',
                description: [
                    "Vitamin D3 improves your body’s ability to absorb calcium, which is increasingly important as you get older because it helps strengthen your bones. Vitamin B6 offers immunity support. Together they enhance MENO's formula as a holistic menopause supplement.*",
                ],
            },
        ],
    },
    _a[UpsellModalName.uroId] = {
        imageDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/uro-id-learn-more-desktop.png?v=1721250039',
        imageMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/uro-id-learn-more-mobile.jpg?v=1721250039',
        sfpImages: [],
        graphicsBlockClass: 'uro-vp',
        productName: 'URO Intimate Deodorant',
        productCount: '1 tube (3 oz.)',
        title: 'Whole Body Odor Control',
        descriptions: [
            'Unscented, aluminum-free cream deodorant designed for sensitive skin. For odor control, moisture control & chafing. ',
        ],
        keyFacts: ['ALUMINUM FREE', 'FRAGRANCE FREE', 'DYE FREE'],
        ingredients: [
            {
                header: 'MANDELIC ACID & LACTIC ACID',
                description: [
                    'These lightweight acids help acidify the skin, which slows the growth of odor-causing bacteria.',
                ],
            },
            {
                header: 'ZINC RICINOLEATE',
                description: [
                    'A compound shown to target and bind onto odor-causing chemicals to help make them odorless.',
                ],
            },
            {
                header: 'PROBIOTIC FERMENT',
                description: [
                    'Fermenting probiotic saccharomyces with sugar cane produces powerful enzymes that can naturally neutralize odor-causing compounds.',
                ],
            },
            {
                header: 'TAPIOCA STARCH & SILICA',
                description: [
                    'Tapioca starch is derived from the tapioca plant, and can help absorb excess moisture. Silica is a natural mineral known to absorb moisture.',
                ],
            },
            {
                header: 'SKIN-SOOTHING BLEND',
                description: [
                    'Aloe, prickly pear extract, olive leaf extract & vitamin E help calm the skin, leaving it feeling smooth and moisturized.',
                ],
            },
        ],
    },
    _a);
